import 'css-chunksrc/client/pages/documentsPage/documentsPage/folder/styles.scss';export default {
  "folder": "_folder_1o8w7_1",
  "icon": "_icon_1o8w7_35",
  "name": "_name_1o8w7_41",
  "childrenNbr": "_childrenNbr_1o8w7_47",
  "avatar": "_avatar_1o8w7_53",
  "creationDate": "_creationDate_1o8w7_58",
  "contextualMenu": "_contextualMenu_1o8w7_63",
  "removeIcon": "_removeIcon_1o8w7_75",
  "loader": "_loader_1o8w7_79"
};